/* eslint-disable jsx-a11y/no-onchange */
import React, { useEffect } from "react";
import * as Styles from "../common/styles/FormsAem";
import * as FormStyles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import Icon, { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import type { DateRangeMap, TradeInAemDetailFormItem } from "../../../utils/types";
import { useTradeInAemLabel } from "../../../utils/labels";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { getHardValidationRule, getMonths } from "../../../utils/utils";
import { TradeInAemDetailFormItemType } from "../../../utils/constants";
import useValidatedTextField from "../../../../common-deprecated/hooks/useValidatedTextField";
import IconWrapper from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useTradeInAemSelector } from "../../../redux/store";

type Props = {
    formItem: TradeInAemDetailFormItem;
    formItemKey: string;
    selectedYear: string;
    range: DateRangeMap;
    showRequiredError?: boolean;
};

const VehicleDetailsDropdown = (props: Props): JSX.Element | null => {
    const { formItem, formItemKey, selectedYear, range, showRequiredError = false } = props;
    const { type, label, description, required } = formItem; // placeholder
    const csl = useTradeInCsl();
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);

    const [requiredLabel, selectLabel, selectYearFirstLabel] = useTradeInAemLabel([
        "tradeInAemFieldRequired",
        "tradeInAemVehicleDetailsSelect",
        "tradeInAemVehicleDetailsFirstSelectYear",
    ]);
    const { errorMessage, setValue, value } = useValidatedTextField(
        formItem.value as string,
        (newValue) => csl.setFormItemValue(formItemKey, newValue),
        {
            showRequiredError,
            requiredLabel,
            required: formItem.required,
            validationRule: formItem.validationRule,
            validationError: formItem.validationError,
            hardValidationRule: getHardValidationRule(type),
        },
    );

    const months = getMonths(commonSettings.country, commonSettings.language);

    useEffect(() => {
        if (type === TradeInAemDetailFormItemType.Month && value)
            if (!range[selectedYear]?.includes(Number(value))) {
                setValue(range[selectedYear]?.[0]?.toString());
            }
    }, [range, selectedYear, setValue, type, value]);

    return (
        <>
            <FormStyles.InputField
                disabled={type === TradeInAemDetailFormItemType.Month && selectedYear === ""}
                hasError={!!errorMessage}
                mt={2}
            >
                <FormStyles.InputLabel htmlFor={formItemKey}>
                    {label} {required && <Styles.MandatoryField largeFontSize>*</Styles.MandatoryField>}
                </FormStyles.InputLabel>
                <FormStyles.Select>
                    <select
                        disabled={type === TradeInAemDetailFormItemType.Month && selectedYear === ""}
                        required={required}
                        onChange={(event) => setValue(event.target.value)}
                        value={value}
                    >
                        <option value="" disabled>
                            {type === TradeInAemDetailFormItemType.Month && selectedYear === ""
                                ? selectYearFirstLabel
                                : selectLabel}
                        </option>
                        {type === TradeInAemDetailFormItemType.Month
                            ? range[selectedYear]?.map((month) => (
                                  <option value={month} key={month}>
                                      {months[month - 1]}
                                  </option>
                              ))
                            : Object.keys(range).map((year) => (
                                  <option value={year} key={year}>
                                      {year}
                                  </option>
                              ))}
                    </select>
                </FormStyles.Select>
                <FormStyles.Icon>
                    <Icon variant="chevronDown" />
                </FormStyles.Icon>
            </FormStyles.InputField>
            {description && <Styles.HelpText>{description}</Styles.HelpText>}
            {!!errorMessage && (
                <FormStyles.ErrorField>
                    <span>{errorMessage}</span>
                    <IconWrapper iconColor="primaryRed">
                        <IconExclamation />
                    </IconWrapper>
                </FormStyles.ErrorField>
            )}
        </>
    );
};

export default VehicleDetailsDropdown;
